export default {
  'storeValueCard.title': 'Stored Value Card',
  'storeValueCard.current_balance': 'Current Balance',
  'storeValueCard.currency': 'TWD',
  'storeValueCard.online_top_up': 'Online Top Up',
  'storeValueCard.deduct': 'Deduct',
  'storeValueCard.transaction_history': 'Transaction History',
  'storeValueCard.update_time': 'Update Time',
  'storeValueCard.total_amount': 'Amount',
  'storeValueCard.store': 'Store',
  'storeValueCard.empty': 'No transaction history yet',
  'storeValueCard.redeem.title': 'Deduct',
  'storeValueCard.redeem.enter_amount': 'Please enter the deduction amount',
  'storeValueCard.redeem.enter_store_code': 'Please enter the redemption code',
  'storeValueCard.redeem.next_step': 'Next',
  'storeValueCard.redeem.success': 'Deduction successful',
  'storeValueCard.redeem.fail': 'Deduction failed',
  'storeValueCard.description.title': 'Usage Instructions',
  'storeValueCard.store.title': 'Online Top Up',
  'storeValueCard.store.coupon_alt': 'Top-up voucher',
  'storeValueCard.store.amount_prefix': 'Top-up {name}',
  'storeValueCard.store.description':
    'Complete the top-up via online card payment. The stored value can be used at all stores.',
  'storeValueCard.store.top_up': 'Top Up',
  'storeValueCard.store.empty': 'No top-up amounts set by the brand',
} as Record<string, string>;
